import { render, staticRenderFns } from "./addPackage.vue?vue&type=template&id=f6319dd8&scoped=true&"
import script from "./addPackage.vue?vue&type=script&lang=js&"
export * from "./addPackage.vue?vue&type=script&lang=js&"
import style0 from "./addPackage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addPackage.vue?vue&type=style&index=1&id=f6319dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6319dd8",
  null
  
)

export default component.exports